// extracted by mini-css-extract-plugin
export default {"negitive":"src-parts-operations-components-PartsOperationsList-components-DurationDisplay__negitive--_JfsP"};